import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function SchoolMobileHeader({ schoolData, mobileMenuOpen, setMobileMenuOpen, handleLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Mobile Header */}
      <header className="mobile-dashboard-header">
        <div className="header-left">
          <div className="school-info">
            <div className="school-name-header">
              {schoolData?.school_name || 'School'}
            </div>
            <div className="school-role-header">School</div>
          </div>
        </div>
        <div className="header-right">
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>
      </header>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-menu-dropdown" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <div className="mobile-user-info">
                <div className="user-avatar">🏫</div>
                <div>
                  <div className="mobile-user-name">{schoolData?.school_name || 'School'}</div>
                  <div className="mobile-user-role">School</div>
                </div>
              </div>
              <button className="mobile-logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </div>
            <div className="mobile-menu-tabs">
              <button 
                className={`mobile-menu-tab ${isActive('/school/dashboard') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/dashboard');
                  setMobileMenuOpen(false);
                }}
              >
                Dashboard
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/classes') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/classes');
                  setMobileMenuOpen(false);
                }}
              >
                Classes
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/students') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/students');
                  setMobileMenuOpen(false);
                }}
              >
                Students
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/student-approvals') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/student-approvals');
                  setMobileMenuOpen(false);
                }}
              >
                Student Approvals
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/parents') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/parents');
                  setMobileMenuOpen(false);
                }}
              >
                Parents
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/teachers') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/teachers');
                  setMobileMenuOpen(false);
                }}
              >
                Teachers
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/transport-persons') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/transport-persons');
                  setMobileMenuOpen(false);
                }}
              >
                Drivers
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/receptionists') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/receptionists');
                  setMobileMenuOpen(false);
                }}
              >
                Receptionists
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/schedule') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/schedule');
                  setMobileMenuOpen(false);
                }}
              >
                Holiday Selection
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/timing') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/timing');
                  setMobileMenuOpen(false);
                }}
              >
                School Timings
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/class-schedule') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/class-schedule');
                  setMobileMenuOpen(false);
                }}
              >
                Class Schedule
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/schedule-view') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/schedule-view');
                  setMobileMenuOpen(false);
                }}
              >
                Schedule
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/card-generation') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/card-generation');
                  setMobileMenuOpen(false);
                }}
              >
                Card Generation
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/exam-schedule') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/exam-schedule');
                  setMobileMenuOpen(false);
                }}
              >
                Exams & Tests
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/exam-report-cards') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/exam-report-cards');
                  setMobileMenuOpen(false);
                }}
              >
                Report Cards
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/notices') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/notices');
                  setMobileMenuOpen(false);
                }}
              >
                Notices
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/set-fees') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/set-fees');
                  setMobileMenuOpen(false);
                }}
              >
                Set Fees
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/fee-schedule') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/fee-schedule');
                  setMobileMenuOpen(false);
                }}
              >
                Fee Schedule
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/fee-records') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/fee-records');
                  setMobileMenuOpen(false);
                }}
              >
                Fee Records
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/student-fees') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/student-fees');
                  setMobileMenuOpen(false);
                }}
              >
                Student Fees
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/attendance-records') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/attendance-records');
                  setMobileMenuOpen(false);
                }}
              >
                Attendance Records
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/homework') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/homework');
                  setMobileMenuOpen(false);
                }}
              >
                Homework
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/vehicle') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/vehicle');
                  setMobileMenuOpen(false);
                }}
              >
                Vehicle
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/pickup-locations') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/pickup-locations');
                  setMobileMenuOpen(false);
                }}
              >
                Pickup Location
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/routes') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/routes');
                  setMobileMenuOpen(false);
                }}
              >
                Routes
              </button>
              <button 
                className={`mobile-menu-tab ${isActive('/school/my-account') ? 'active' : ''}`}
                onClick={() => {
                  navigate('/school/my-account');
                  setMobileMenuOpen(false);
                }}
              >
                My Account
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}









